import React from 'react';
import PropTypes from 'prop-types';

import './Checkbox.css';

const Checkbox = ({ id, disabled, ...rest }) => (
  <label htmlFor={id} className={`custom-checkbox ${disabled ? 'disabled' : ''}`}>
    <input id={id} name={id} type="checkbox" disabled={disabled} {...rest} />
    <span />
  </label>
);

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  disabled: false,
};

export default Checkbox;
